import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';

export const Container = styled.div`
  width: ${({ Width }) => (Width ? Width : '100%')};
  position: relative;
  overflow: hidden;
`;

export const BgContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

export const BgImage = styled(GatsbyImage)`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

export const BgContent = styled.div`
  width: 100%;
  height: 100%;
`;
